import PropTypes from "prop-types"
import React from 'react';
import MuiGrid from '@mui/material/Grid';

export function Grid ({
  children,
  container = false,
  mobile,
  desktop,
  spacing,
  sx,
  noStyle = false,
  component = 'div',
  ...rest
}){
  const xs = mobile ?? 12;
  const md = desktop ?? 12;
  const style = noStyle ? {} : sx || { padding: "10px", mt: 2 };

  const sizeProps = container
    ? {}
    : {
        xs,
        md,
      };

  return (
    <MuiGrid
      container={container}
      spacing={spacing}
      component={component}
      sx={{ ...style }}
      {...sizeProps}
      {...rest}
    >
      {children}
    </MuiGrid>
  );
};

Grid.propTypes = {
  children: PropTypes.any,
  component: PropTypes.string,
  container: PropTypes.bool,
  desktop: PropTypes.number,
  mobile: PropTypes.number,
  noStyle: PropTypes.bool,
  spacing: PropTypes.any,
  sx: PropTypes.shape({
    padding: PropTypes.string,
    mt: PropTypes.number
  })
}
